import { useCallback } from 'react';
import { useParams } from 'react-router';

import { useRenewSubscriptionMutation } from 'store/api/version-api.slice';

import useDispatchMessage from './useDispatchMessage';

const useRenewWithCardOnFileSquare = ({ member, setPaymentStatus }) => {
	const params = useParams();

	const dispatchMessage = useDispatchMessage();

	const [renewSubscriptionWithCardOnFile, { isLoading: isRenewLoading }] = useRenewSubscriptionMutation();

	const handler = useCallback(
		async data => {
			try {
				const renewData = {
					email: member.email,
					member_type: data.member_type,
					sq_customer_id: member.sq_customer_id,
					sq_customer_card_id: data.card_on_file.id,
					sq_postal_code: data.card_on_file.billing_address.postal_code
				};

				const result = await renewSubscriptionWithCardOnFile({
					portalId: params.portal_id,
					contactId: params.contact_id,
					data: renewData
				});

				if (result?.data.status === 'COMPLETED') {
					const { currency, amount } = result.data.total_money;
					const format_amount = (amount / 100).toFixed(2);
					const message = `Your payment of ${format_amount} ${currency.toUpperCase()} has been processed successfully`;

					dispatchMessage({ message });
					setPaymentStatus('SUCCESS');
				} else {
					dispatchMessage({
						message: 'Payment Failed! Please, try again later',
						variant: 'error'
					});
					setPaymentStatus('ERROR');
				}
			} catch (e) {
				dispatchMessage({
					message: 'Payment Failed! Please, try again later',
					variant: 'error'
				});
				setPaymentStatus('ERROR');
			}
		},
		[
			dispatchMessage,
			member.email,
			member.sq_customer_id,
			params.contact_id,
			params.portal_id,
			renewSubscriptionWithCardOnFile,
			setPaymentStatus
		]
	);

	return { handler, isRenewLoading };
};

export default useRenewWithCardOnFileSquare;
